import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import { mapToObjectDDL } from "../../../common/mapper";

class PengajuanSSUFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warnaOptions: [],
    };
  }

  componentDidMount = () => {
    const { options } = this.props;
    let warnaOptions = [{ label: "ALL", value: "ALL" }];
    if (
      !R.isNil(this.props.state.filterData) &&
      !R.isNil(this.props.state.filterData?.variant)
    ) {
      let kodeVariant = this.props.state.filterData.variant.map((v) => v.value);

      if (kodeVariant.includes("ALL")) {
        warnaOptions = [...warnaOptions, ...options.warnaOptions];
      } else if (!R.isNil(kodeVariant) || !R.isEmpty(kodeVariant)) {
        let warna = options.warnaRaw.filter((w) =>
          kodeVariant.includes(w.kodeVariant)
        );
        warnaOptions = [
          ...warnaOptions,
          ...warna.map((w) => mapToObjectDDL(w.namaWarnaPabrik, w.id)),
        ];
      }
    }

    this.setState({
      warnaOptions,
    });
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    const prevVariant = R.pathOr(
      [],
      ["state", "filterData", "variant"],
      prevProps
    );
    const currVariant = R.pathOr(
      [],
      ["state", "filterData", "variant"],
      this.props
    );

    const prevValues = R.sortBy(R.identity, R.pluck("value", prevVariant));
    const currValues = R.sortBy(R.identity, R.pluck("value", currVariant));

    if (!R.equals(prevValues, currValues)) {
      console.log("Variant changed:");
      console.log("Prev:", prevVariant);
      console.log("Curr:", currVariant);

      let warnaOptions = [];
      const kodeVariant = currValues;

      let warna = [];

      if (!R.isEmpty(kodeVariant)) {
        if (kodeVariant.includes("ALL")) {
          warna = this.props.options.warnaRaw;
          warnaOptions.push({ label: "ALL", value: "ALL" });
        } else {
          warna = this.props.options.warnaRaw.filter((w) =>
            kodeVariant.includes(w.kodeVariant)
          );
        }

        warnaOptions = [
          ...warnaOptions,
          ...warna.map((w) => mapToObjectDDL(w.namaWarnaPabrik, w.id)),
        ];
      }
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions,
      }));

      const currentWarnaValue = this.getFilterDataValue("warna", []);
      const warnaIDs = warna.map((w) => w.id);
      const filteredWarnaValue = currentWarnaValue.filter((w) =>
        warnaIDs.includes(w.value)
      );

      if (!R.equals(currentWarnaValue, filteredWarnaValue)) {
        this.props.onChange("warna", filteredWarnaValue);
      }
    }
  };

  getFilterDataValue = (fieldName, fallbackValue = "") => {
    return !R.isNil(this.props.state.filterData) &&
      this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  };

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <form onSubmit={this.props.onSubmit}>
              <FlexView column vAlignContent="center">
                <div className="txt-site txt-11 txt-main txt-bold">
                  <h4>Tanggal Faktur Jual</h4>
                </div>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleDate
                    id="select_date_startDateFaktur"
                    name="fromTime"
                    nextdate
                    date={this.props.state.filterData.fromTime}
                    maxDate={this.getFilterDataValue("toTime", null)}
                    onChange={(value) => this.props.onChange("fromTime", value)}
                  />
                  <span className="margin-bottom-20px">-</span>
                  <SimpleDate
                    id="select_date_endDateFaktur"
                    name="toTime"
                    nextdate
                    date={this.props.state.filterData.toTime}
                    onChange={(value) => this.props.onChange("toTime", value)}
                  />
                </FlexView>
                <SimpleInput
                  id="input_text_no_faktur_jual"
                  name="salesFakturNo"
                  label="No. Faktur Jual"
                  value={this.getFilterDataValue("salesFakturNo")}
                  onChange={({ target }) =>
                    this.props.onChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_no_buku"
                  name="bookNo"
                  label="No. Buku"
                  value={this.getFilterDataValue("bookNo")}
                  onChange={({ target }) =>
                    this.props.onChange(target.name, target.value)
                  }
                />
                <SimpleDDL
                  id="select_options_nama_varian"
                  box="multiselect"
                  name="variant"
                  label="Nama Varian"
                  isClearable
                  options={this.props.options.variantOptions}
                  value={this.getFilterDataValue("variant", null)}
                  onChange={(value, { name }) => {
                    this.props.onChange(name, value);
                    if (!value || value.length === 0) {
                      this.props.onChange("warna", []);
                    }
                  }}
                />
                <SimpleDDL
                  id="select_options_nama_warna"
                  box="multiselect"
                  name="warna"
                  label="Nama Warna"
                  isClearable
                  options={this.state.warnaOptions}
                  value={this.getFilterDataValue("warna", null)}
                  onChange={(value, { name }) =>
                    this.props.onChange(name, value)
                  }
                  isDisabled={
                    !this.getFilterDataValue("variant", null) ||
                    this.getFilterDataValue("variant", null).length === 0
                  }
                />
                <SimpleInput
                  id="input_text_nama_stnk"
                  name="stnkName"
                  label="Nama STNK"
                  value={this.getFilterDataValue("stnkName")}
                  onChange={({ target }) =>
                    this.props.onChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_nama_pembeli"
                  name="customerName"
                  label="Nama Pembeli"
                  value={this.getFilterDataValue("customerName")}
                  onChange={({ target }) =>
                    this.props.onChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_nomor_rangka"
                  name="frameNumber"
                  label="Nomor Rangka"
                  value={this.getFilterDataValue("frameNumber")}
                  onChange={({ target }) =>
                    this.props.onChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_nomor_mesin"
                  name="engineNumber"
                  label="Nomor Mesin"
                  value={this.getFilterDataValue("engineNumber")}
                  onChange={({ target }) =>
                    this.props.onChange(target.name, target.value)
                  }
                />
                <FlexView hAlignContent="center">
                  <SimpleButton
                    type="button"
                    secondary
                    onClick={this.props.onReset}
                  >
                    Hapus
                  </SimpleButton>
                  <SimpleButton type="submit">Terapkan</SimpleButton>
                </FlexView>
              </FlexView>
            </form>
          </ModalContainer>
        }
      />
    );
  }
}

export default PengajuanSSUFilter;
